import { createTheme } from '@mui/material';

export const theme = createTheme({
breakpoints: {
  values: {
    xs: 0,
    sm: 600,
    md: 1000,
    lg: 1200,
    xl: 1920
  }
},
components: {
  MuiButton: {
    defaultProps: {
      disableElevation: true
    },
    styleOverrides: {
      root: {
        textTransform: 'none',
        fontSize: '0.7rem' // 80% of default ~0.875rem
      },
      sizeSmall: {
        padding: '4.8px 12.8px'
      },
      sizeMedium: {
        padding: '6.4px 16px'
      },
      sizeLarge: {
        padding: '8.8px 19.2px'
      },
      textSizeSmall: {
        padding: '5.6px 9.6px'
      },
      textSizeMedium: {
        padding: '7.2px 12.8px'
      },
      textSizeLarge: {
        padding: '9.6px 12.8px'
      }
    }
  },
  // MuiTab: {
  //   styleOverrides: {
  //     root: {
  //       fontSize: '0.7rem', // Reduce font size for tabs
  //       minHeight: '32px', // Optional: reduce height too
  //       padding: '6px 12px'
  //     }
  //   }
  // },
  MuiTab: {
    styleOverrides: {
      root: {
        fontSize: '0.7rem', // Reduce font size for tabs
        // minHeight: '32px', // Optional: reduce height too
        padding: '6px 12px'
      }
    }
  },
  MuiChip: {
    styleOverrides: {
      root: {
        fontSize: '0.7rem', // Reduce font size in chips
        height: '24px',
        padding: '0 8px'
      },
      label: {
        paddingLeft: '4px',
        paddingRight: '4px'
      }
    }
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true
    }
  },
  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: '25.6px 19.2px', // 80% of 32px 24px
        '&:last-child': {
          paddingBottom: '25.6px'
        }
      }
    }
  },
  MuiCardHeader: {
    defaultProps: {
      titleTypographyProps: {
        variant: 'h6'
      },
      subheaderTypographyProps: {
        variant: 'body2'
      }
    },
    styleOverrides: {
      root: {
        padding: '25.6px 19.2px'
      }
    }
  },
  MuiCssBaseline: {
    styleOverrides: {
      '*': {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0
      },
      html: {
        MozOsxFontSmoothing: 'grayscale',
        WebkitFontSmoothing: 'antialiased',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
        width: '100%'
      },
      body: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        minHeight: '100%',
        width: '100%'
      },
      '#__next': {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        height: '100%',
        width: '100%'
      }
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      notchedOutline: {
        borderColor: '#E6E8F0'
      }
    }
  },
  MuiTableHead: {
    styleOverrides: {
      root: {
        backgroundColor: '#F3F4F6',
        '.MuiTableCell-root': {
          color: '#374151'
        },
        borderBottom: 'none',
        '& .MuiTableCell-root': {
          borderBottom: 'none',
          fontSize: '9.6px',
          fontWeight: 600,
          lineHeight: 0.8,
          letterSpacing: 0.4,
          textTransform: 'uppercase'
        },
        '& .MuiTableCell-paddingCheckbox': {
          paddingTop: 3.2,
          paddingBottom: 3.2
        }
      }
    }
  }
},
shape: {
  borderRadius: 6.4 // 80% of 8
},
typography: {
  button: {
    fontWeight: 600
  },
  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
  body1: {
    fontSize: '0.8rem',
    fontWeight: 400,
    lineHeight: 1.2
  },
  body2: {
    fontSize: '0.7rem',
    fontWeight: 400,
    lineHeight: 1.256
  },
  subtitle1: {
    fontSize: '0.8rem',
    fontWeight: 500,
    lineHeight: 1.4
  },
  subtitle2: {
    fontSize: '0.7rem',
    fontWeight: 500,
    lineHeight: 1.256
  },
  overline: {
    fontSize: '0.6rem',
    fontWeight: 600,
    letterSpacing: '0.4px',
    lineHeight: 2,
    textTransform: 'uppercase'
  },
  caption: {
    fontSize: '0.6rem',
    fontWeight: 400,
    lineHeight: 1.33
  },
  h1: {
    fontWeight: 700,
    fontSize: '2.8rem',
    lineHeight: 1.1
  },
  h2: {
    fontWeight: 700,
    fontSize: '2.4rem',
    lineHeight: 1.1
  },
  h3: {
    fontWeight: 700,
    fontSize: '1.8rem',
    lineHeight: 1.1
  },
  h4: {
    fontWeight: 700,
    fontSize: '1.6rem',
    lineHeight: 1.1
  },
  h5: {
    fontWeight: 600,
    fontSize: '1.2rem',
    lineHeight: 1.1
  },
  h6: {
    fontWeight: 600,
    fontSize: '0.9rem',
    lineHeight: 1.1
  }
},
  palette: {
    neutral: {
      100: '#F3F4F6',
      200: '#E5E7EB',
      300: '#D1D5DB',
      400: '#9CA3AF',
      500: '#6B7280',
      600: '#4B5563',
      700: '#374151',
      800: '#1F2937',
      900: '#111827'
    },
    action: {
      active: '#6B7280',
      focus: 'rgba(55, 65, 81, 0.12)',
      hover: 'rgba(55, 65, 81, 0.04)',
      selected: 'rgba(55, 65, 81, 0.08)',
      disabledBackground: 'rgba(55, 65, 81, 0.12)',
      disabled: 'rgba(55, 65, 81, 0.26)'
    },
    background: {
      default: '#F9FAFC',
      paper: '#FFFFFF'
    },
    divider: '#E6E8F0',
    primary: {
      main: '#357be4',
      light: '#72a7f7',
      dark: '#26569e',
      contrastText: '#FFFFFF'
    },
    secondary: {
      main: '#10B981',
      light: '#3FC79A',
      dark: '#0B815A',
      contrastText: '#FFFFFF'
    },
    success: {
      main: '#14B8A6',
      light: '#43C6B7',
      dark: '#0E8074',
      contrastText: '#FFFFFF'
    },
    info: {
      main: '#2196F3',
      light: '#64B6F7',
      dark: '#0B79D0',
      contrastText: '#FFFFFF'
    },
    warning: {
      main: '#FFB020',
      light: '#FFBF4C',
      dark: '#B27B16',
      contrastText: '#FFFFFF'
    },
    error: {
      main: '#D14343',
      light: '#DA6868',
      dark: '#922E2E',
      contrastText: '#FFFFFF'
    },
    text: {
      primary: '#121828',
      secondary: '#65748B',
      disabled: 'rgba(55, 65, 81, 0.48)'
    }
  },  
  shadows: [
    'none',
    '0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)',
    '0px 1px 2px rgba(100, 116, 139, 0.12)',
    '0px 1px 4px rgba(100, 116, 139, 0.12)',
    '0px 1px 5px rgba(100, 116, 139, 0.12)',
    '0px 1px 6px rgba(100, 116, 139, 0.12)',
    '0px 2px 6px rgba(100, 116, 139, 0.12)',
    '0px 3px 6px rgba(100, 116, 139, 0.12)',
    '0px 2px 4px rgba(31, 41, 55, 0.06), 0px 4px 6px rgba(100, 116, 139, 0.12)',
    '0px 5px 12px rgba(100, 116, 139, 0.12)',
    '0px 5px 14px rgba(100, 116, 139, 0.12)',
    '0px 5px 15px rgba(100, 116, 139, 0.12)',
    '0px 6px 15px rgba(100, 116, 139, 0.12)',
    '0px 7px 15px rgba(100, 116, 139, 0.12)',
    '0px 8px 15px rgba(100, 116, 139, 0.12)',
    '0px 9px 15px rgba(100, 116, 139, 0.12)',
    '0px 10px 15px rgba(100, 116, 139, 0.12)',
    '0px 12px 22px -8px rgba(100, 116, 139, 0.25)',
    '0px 13px 22px -8px rgba(100, 116, 139, 0.25)',
    '0px 14px 24px -8px rgba(100, 116, 139, 0.25)',
    '0px 10px 10px rgba(31, 41, 55, 0.04), 0px 20px 25px rgba(31, 41, 55, 0.1)',
    '0px 25px 50px rgba(100, 116, 139, 0.25)',
    '0px 25px 50px rgba(100, 116, 139, 0.25)',
    '0px 25px 50px rgba(100, 116, 139, 0.25)',
    '0px 25px 50px rgba(100, 116, 139, 0.25)'
  ],
});
